'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken from "./presto.types$-Single-App-Token.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SingleAppToken$() {
}
export { $c_Lpresto_types$SingleAppToken$ as $c_Lpresto_types$SingleAppToken$ };
$p = $c_Lpresto_types$SingleAppToken$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SingleAppToken$;
/** @constructor */
function $h_Lpresto_types$SingleAppToken$() {
}
export { $h_Lpresto_types$SingleAppToken$ as $h_Lpresto_types$SingleAppToken$ };
$h_Lpresto_types$SingleAppToken$.prototype = $p;
$p.l = (function() {
  return "SingleAppToken";
});
$p.ade = (function(x$0) {
  return new $j_presto$002etypes$0024$002dSingle$002dApp$002dToken.$c_Lpresto_types$SingleAppToken(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_types$SingleAppToken$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SingleAppToken$, "presto.types$SingleAppToken$", ({
  a1I: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$SingleAppToken$ as $d_Lpresto_types$SingleAppToken$ };
var $n_Lpresto_types$SingleAppToken$;
function $m_Lpresto_types$SingleAppToken$() {
  if ((!$n_Lpresto_types$SingleAppToken$)) {
    $n_Lpresto_types$SingleAppToken$ = new $c_Lpresto_types$SingleAppToken$();
  }
  return $n_Lpresto_types$SingleAppToken$;
}
export { $m_Lpresto_types$SingleAppToken$ as $m_Lpresto_types$SingleAppToken$ };
//# sourceMappingURL=presto.types$-Single-App-Token$.js.map
